// This file is auto-generated. Do not edit manually.
// Run `yarn tokens:build` to regenerate.

import { ArrayValues } from 'type-fest';

export const typographyVariants = [
  'A1',
  'A2',
  'A3',
  'C12',
  'C14',
  'C16',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'L10B',
  'L10M',
  'L10R',
  'L12B',
  'L12M',
  'L12R',
  'L14B',
  'L14M',
  'L14R',
  'L8M',
  'metriclg',
  'metricmd',
  'metricsm',
  'metricxs',
  'P10B',
  'P10M',
  'P10R',
  'P12B',
  'P12M',
  'P12R',
  'P14B',
  'P14M',
  'P14R',
  'P16B',
  'P16M',
  'P16R',
  'P18B',
  'P18M',
  'P18R',
  'P20B',
  'P20M',
  'P20R',
  'P40B',
  'P8B',
  'P8M',
] as const;

export type TypographyVariant = ArrayValues<typeof typographyVariants>;

export const typographyClassNames: Record<TypographyVariant, string> = {
  A1: 'typography-A1',
  A2: 'typography-A2',
  A3: 'typography-A3',
  C12: 'typography-C12',
  C14: 'typography-C14',
  C16: 'typography-C16',
  h1: 'typography-h1',
  h2: 'typography-h2',
  h3: 'typography-h3',
  h4: 'typography-h4',
  h5: 'typography-h5',
  h6: 'typography-h6',
  L10B: 'typography-L10B',
  L10M: 'typography-L10M',
  L10R: 'typography-L10R',
  L12B: 'typography-L12B',
  L12M: 'typography-L12M',
  L12R: 'typography-L12R',
  L14B: 'typography-L14B',
  L14M: 'typography-L14M',
  L14R: 'typography-L14R',
  L8M: 'typography-L8M',
  metriclg: 'typography-metriclg',
  metricmd: 'typography-metricmd',
  metricsm: 'typography-metricsm',
  metricxs: 'typography-metricxs',
  P10B: 'typography-P10B',
  P10M: 'typography-P10M',
  P10R: 'typography-P10R',
  P12B: 'typography-P12B',
  P12M: 'typography-P12M',
  P12R: 'typography-P12R',
  P14B: 'typography-P14B',
  P14M: 'typography-P14M',
  P14R: 'typography-P14R',
  P16B: 'typography-P16B',
  P16M: 'typography-P16M',
  P16R: 'typography-P16R',
  P18B: 'typography-P18B',
  P18M: 'typography-P18M',
  P18R: 'typography-P18R',
  P20B: 'typography-P20B',
  P20M: 'typography-P20M',
  P20R: 'typography-P20R',
  P40B: 'typography-P40B',
  P8B: 'typography-P8B',
  P8M: 'typography-P8M',
};
